export default "__VITE_ASSET__DLYqajLo__"